import { t } from "i18next";
import React, { useEffect, useRef, useState } from "react";
import "./SelectProviders.scss";

interface ISelectProviders {
  handleSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  searchInput: string;
}

const SelectProviders = ({
  handleSearchChange,
  searchInput,
}: ISelectProviders) => {
  const wrapperRef = useRef(null);

  const [inputActive, setInputActive] = useState(false);


  const handleTapOutside = (event: MouseEvent | TouchEvent) => {
    if (
      wrapperRef.current &&
      !(wrapperRef.current as HTMLElement).contains(event.target as Node)
    ) {
      setInputActive(false);
    }
  };

  const handleOpenInput = () => {
    setInputActive((prev) => !prev);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleTapOutside);
    document.addEventListener("touchstart", handleTapOutside);
    return () => {
      document.removeEventListener("mousedown", handleTapOutside);
      document.removeEventListener("touchstart", handleTapOutside);
    };
  }, []);

  return (
    <div className="accordion-title" ref={wrapperRef}>
      <div className="page-view-more">
        <h3 className="view-title-more ellipsis custom-font-size">
          {t("casino.Providers")}
        </h3>
      </div>
      <span className="accordion-reset-button">{t("casino.Reset")}</span>
      <div
        className={`sport-search-bc ${
          inputActive ? "active" : ""
        } search-custom`}
      >
        {inputActive ? (
          <input
            type="text"
            className="ss-input-bc"
            placeholder="Search provider..."
            defaultValue=""
            value={searchInput}
            onChange={handleSearchChange}
          />
        ) : null}
        <div
          className="ss-icon-holder-bc custom-btn-position"
          onClick={handleOpenInput}
        >
          <i
            className={`ss-icon-bc bc-i-${
              inputActive ? "close-remove" : "search"
            }`}
          />
        </div>
      </div>
    </div>
  );
};

export { SelectProviders };
